import React from "react";

import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { useDrag } from "react-dnd";
import { makeStyles, withStyles } from "tss-react/mui";

import { colors } from "@/theme/overrides/colors";

import { ComponentProps, DragType } from "../utils/types";

const useStyles = makeStyles()(() => ({
  root: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: colors.light,
    width: "100%",
    padding: 8,
    marginBottom: 8,
  },

  header: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
}));

const StyledDragIndicatorIcon = withStyles(DragIndicatorIcon, () => ({
  root: {
    color: colors.gray,
  },
}));

const VerticalSingleSelector: React.FC<ComponentProps> = ({
  componentType,
}) => {
  const [, drag] = useDrag({
    type: DragType.COMPONENT,
    item: () => {
      return componentType;
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });
  const { classes } = useStyles();
  const [value, setValue] = React.useState("item 1");

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue((event.target as HTMLInputElement).value);
  };

  return (
    <div className={classes.root} ref={drag}>
      <Box className={classes.header}>
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography
            variant="h6"
            color="textPrimary"
            style={{ marginBottom: 12 }}
          >
            Vertical Single Selector
          </Typography>
          <StyledDragIndicatorIcon />
        </Box>
        <FormControl component="fieldset">
          <RadioGroup
            aria-label="gender"
            name="gender1"
            value={value}
            onChange={handleChange}
          >
            <FormControlLabel value="item 1" control={<Radio />} label="Item" />
            <FormControlLabel value="item 2" control={<Radio />} label="Item" />
          </RadioGroup>
        </FormControl>
      </Box>
    </div>
  );
};

export default VerticalSingleSelector;
